"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.timeSpan = void 0;
var ms_1 = __importDefault(require("ms"));
var timeSpan = function (val) {
    var err_str = '"expires_in" argument should be a number of milliseconds or a string representing a timespan eg: "1d", "20h", 60';
    if (typeof val === 'string') {
        var milliseconds = (0, ms_1["default"])(val);
        if (typeof milliseconds === 'undefined') {
            throw new Error(err_str);
        }
        return new Date(Date.now() + milliseconds);
    }
    else if (typeof val === 'number') {
        return new Date(Date.now() + val);
    }
    else {
        throw new Error(err_str);
    }
};
exports.timeSpan = timeSpan;
